// src/onboarding/types.ts

export type EntryMode = "goalFirst" | "financialFirst" | "unknown"

export interface Goal {
  id: string
  title: string      // Indonesian label for display
  emoji: string      // Icon character
  type: string
}

export interface PlanningContext {
  self: boolean
  child: boolean
  spousePartner: boolean
  family: boolean
  otherDependent: boolean
  multiplePeople: boolean
}

export interface OnboardingState {
  entryMode: EntryMode | null
  selectedGoals: Goal[]
  planningContext: PlanningContext
}

export function emptyOnboardingState(): OnboardingState {
  return {
    entryMode: null,
    planningContext: {
      self: false,
      child: false,
      spousePartner: false,
      family: false,
      otherDependent: false,
      multiplePeople: false,
    },
    selectedGoals: [],
  }
}
